import React from 'react';

export default function LabFilterBar({ children, actions }) {
  return (
    <div className="lab-filter-bar">
      <div className="lab-filter-fields">{children}</div>
      {actions ? <div className="lab-filter-actions">{actions}</div> : null}
    </div>
  );
}
